import React, { useState } from 'react';
import { Alert, Button, message } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import ConfirmAction from '@/components/confirmaction';
import { bindPostSchool } from '@/apis/schools';
import { syncPostMetrics } from '@/store/modules/posts';
import usePrivateAction from '@/utils/usePrivateAction';
import { BankOutlined } from '@ant-design/icons';
import './index.scss';

const PostSchoolBinding = ({ post, onChanged }) => {
  const { userInfo } = useSelector(state => state.user); const dispatch = useDispatch();
  const { busy, run } = usePrivateAction(); const [bound, setBound] = useState(false);
  if (post.school != null || bound) return null;
  return <Alert className="postSchoolBinding" type="info" showIcon icon={<BankOutlined />} title="旧帖尚未设置学校" description="此帖暂不显示在公共列表中。补充学校不会改变活动状态。" action={userInfo?.school ?
    <ConfirmAction title={`确认将此帖补充到${userInfo.school_name || '当前学校'}？设置后不能跨校改绑。`} disabled={busy} onConfirm={() => run(() => bindPostSchool(post.id), result => { dispatch(syncPostMetrics({ postId: post.id, post: { school: result.school } })); setBound(true); message.success('帖子学校已补充'); onChanged?.(); })}>
      <Button loading={busy}>补充学校</Button>
    </ConfirmAction> : <Link to="/personal/info">先选择学校</Link>} />;
};
export default PostSchoolBinding;
